import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from '../../../components/RequestDefinition';

const getMemoListRequest: RequestExample = {
    title: {
        verb: 'GET',
        endpointUrl: '/api/<OBJECT ENDPOINT>/:id/memos',
    },
    curl:
        `curl --location \\
--request GET '<YOUR SERVER>/api/<OBJECT ENDPOINT>/:id/memos' \\
--header 'Authorization: Bearer <TOKEN>'
`,
};

const getMemoListResponse: Json = {
    title: 'RESPONSE',
    json: [
        {
            "id": 43,
            "memo": "This is my other memo",
            "username": "dave",
            "dateCreated": "2021-02-26T14:22:16.383-0700"
        },
        {
            "id": 42,
            "memo": "This is a memo",
            "username": "dave",
            "dateCreated": "2021-02-26T13:59:53.171-0700"
        }
    ]
};

const data: RequestDefinitionData = {
    id: 'get-memo-list',
    title: 'Get a list of memos',
    description: 'Retrieves a list of memos for the specific object. Requires the object\'s VIEW access right. Location group restrictions depend on the object type: for sales orders, purchase orders, work orders and manufacture orders, and for transfer orders (checked against both their from and ship-to location groups), read-only access is sufficient and a 403 is returned only when the user has no access at all. Parts, products and vendors have no location group.',
    endpoint: {
        verb: 'GET',
        path: '/<OBJECT ENDPOINT>/:id/memos',
        tooltip: 'Get a list of memos',
    },
    attributes: [],
    requestObject: getMemoListRequest,
    responseObject: getMemoListResponse,
};

export default data;
